import React from 'react';
import { useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment'
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField'
import Badge from '@mui/material/Badge'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'
import Divider from '@mui/material/Divider';
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import EditIcon from '@mui/icons-material/Edit'
import RefreshIcon from '@mui/icons-material/Refresh'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import DiscountIcon from '@mui/icons-material/Discount';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound'
import PercentIcon from '@mui/icons-material/Percent'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import PersonIcon from '@mui/icons-material/Person'
import AccountBoxIcon from '@mui/icons-material/AccountBox';

import {Context as AppContext} from '../../contexts/App'
import CurrencySelection from './currencySelection'
import ClientSelection from './clientSelection'
import SupplierSelection from './supplierSelection'
import ProductDiscount from './productDiscount'
import ProductSeason from './productSeason'
import ProductCost from './productCost'
import ProductDimensions from './productDimensions'
import ProductDelete from './productDelete'
import Table from '../../components/MUITable'
import money from '../../components/Money'
import { roleCheck } from '../../contexts/Auth';
import { Alert } from '@mui/material';

const user_roles = ["system_manager"]

const getCost = (cost, discount, season, l) => {
  if(l && l.sku == "MLM1922910141")
    console.log("Cost: ", cost, discount, season, l)
  return cost/100 * ((100 - discount)/100) * ((100 - season)/100)
}
const Discount = ({row}) => {

  const discount = row.discount ? (row.discount > 0? " - " : " + ") + `${Math.abs(row.discount)}%`: ''
  const season = row.season ? (row.season > 0? " - " : " + ") + `${Math.abs(row.season)}%`: ''
  const modifiers = `${discount}${season}`
  
  const cost = getCost(row.cost, row.discount, row.season)
  
  return (
    <Typography variant="h6" color={Number(row.cost)>0?"":"error"}>{row.currency.name} {money.format(cost)}<br/>{ row.discount || row.season? <small>{money.format(row.cost/100)} {modifiers}</small> : ''}</Typography>
  )
}


const ProductList = ({setOpen}) => {
  
  const app = React.useContext(AppContext)
  const { vendors } = app
  const { clients } = app.clients
  const { suppliers } = app.suppliers
  const { products, totalProducts, setSelectedProduct, selectedProducts, setSelectedProducts, refresh } = app.products
  const [ openCurrency, setOpenCurrency ] = React.useState(false)
  const [ openClient, setOpenClient ] = React.useState(false)
  const [ openSupplier, setOpenSupplier ] = React.useState(false)
  const [ openDiscount, setOpenDiscount ] = React.useState(false)
  const [ openSeason, setOpenSeason ] = React.useState(false)
  const [ openCost, setOpenCost ] = React.useState(false)
  const [ openDimensions, setOpenDimensions ] = React.useState(false)
  const [ openDelete, setOpenDelete ] = React.useState(false)
  const [seasonFilter, setSeasonFilter] = React.useState(null)
  const [discountFilter, setDiscountFilter] = React.useState(null)
  const [clientFilter, setClientFilter] = React.useState(null)
  const [supplierFilter, setSupplierFilter] = React.useState(null)
  const [clientId, setClientId] = React.useState(0)
  const [supplierId, setSupplierId] = React.useState(0)
  const [vendorName, setVendorName] = React.useState(0)  
  
  const close = (refreshProducts) => {
    if(refreshProducts)
      refresh()
    setOpenCurrency(false)
    setOpenClient(false)
    setOpenSupplier(false)
    setOpenDiscount(false)
    setOpenSeason(false)
    setOpenCost(false)
    setOpenDimensions(false)
    setSelectedProduct(false)
    setSelectedProducts(false)
    setselected([])
  }

  const performSelection = () => new Promise( resolve => resolve(setSelectedProducts( products.filter(p => selected.includes(p.id)).map(p => p.id) ) ) )

  const assignCurrency = () => {
    if(selected.length > 0){
      performSelection().then(() => setOpenCurrency(true))
    }
  }  
  const assignClient = () => {
    if(selected.length > 0){
      performSelection().then(() => setOpenClient(true))
    }
  }  
  const assignSupplier = () => {
    if(selected.length > 0){
      performSelection().then(() => setOpenSupplier(true))
    }
  }  
  const bulkEditDiscount = ()=> {
    if(selected.length > 0){
      performSelection().then(() => setOpenDiscount(true))
    }
  }
  const bulkEditSeason = ()=> {
    if(selected.length > 0){
      performSelection().then(() => setOpenSeason(true))
    }
  }
  const bulkEditCost = ()=> {
    if(selected.length > 0){
      performSelection().then(() => setOpenCost(true))
    }
  }
  const bulkEditDimensions = ()=> {
    if(selected.length > 0){
      performSelection().then(() => setOpenDimensions(true))
    }
  }
  const bulkDelete = ()=> {
    if(selected.length > 0){
      performSelection().then(() => setOpenDelete(true))
    }
  }
  const edit =() => {
    if(selected.length == 1)
      setSelectedProduct(products.find(p => selected.includes(p.id)))
  }

  React.useEffect(() => {
    if(!selectedProducts){
      setOpenCurrency(false)
      setOpenClient(false)
      setOpenSupplier(false)
      setOpenDiscount(false)
      setOpenSeason(false)
      setOpenCost(false)
      setOpenDimensions(false)
      setOpenDelete(false)
    }
  }, [selectedProducts])

  const appliedFilters = (product) => {
    let meetsClient = clientFilter == null, 
      meetsSupplier = supplierFilter == null,
      meetsSeason = seasonFilter == null, 
      meetsDiscount = discountFilter == null, 
      meetsSelectedVendor = vendorName == 0,
      meetsSelectedClient = clientId == 0,
      meetsSelectedSupplier = supplierId == 0

    if(!meetsClient){
      if(clientFilter)
        meetsClient = product.listings.reduce((c, l) => (c && l.client && l.client.name)? true: false, true)
      else
        meetsClient = product.listings.reduce((c, l) => c || (l.client && l.client.name? false: true), false)
    }

    if(!meetsSupplier)
      if(supplierFilter)
        meetsSupplier = product.listings.reduce((s, l) => (s && l.supplier && l.supplier.name)? true: false, true)
      else
        meetsSupplier = product.listings.reduce((s, l) => s || (l.supplier && l.supplier.name? false: true), false)
        
    if(!meetsSeason){
      if(seasonFilter)
        meetsSeason = product.listings.reduce((d, l) => (d && l.season)? true: false, true)
      else
        meetsSeason = product.listings.reduce((d, l) => d || (l.season? false: true), false)
    }

    if(!meetsDiscount){
      if(discountFilter)
        meetsDiscount = product.listings.reduce((d, l) => (d && l.discount)? true: false, true)
      else
        meetsDiscount = product.listings.reduce((d, l) => d || (l.discount? false: true), false)
    }

    if(!meetsSelectedVendor){
      meetsSelectedVendor = product.listings.find(l => l.vendor === vendorName)? true: false
    }

    if(!meetsSelectedClient)
      meetsSelectedClient = product.listings.find(l => l.client && l.client.id === clientId)? true: false

    if(!meetsSelectedSupplier)
      meetsSelectedSupplier = product.listings.find(l => l.supplier && l.supplier.id === supplierId)? true: false

    return meetsClient && meetsSupplier && meetsSeason && meetsDiscount && meetsSelectedVendor && meetsSelectedClient && meetsSelectedSupplier
  }

  
  const filterSupplier = () => {
    setSupplierFilter(supplierFilter == null?true:supplierFilter?false:null)
  }
  const filterClient = () => {
    setClientFilter(clientFilter == null?true:clientFilter?false:null)
  }
  const filterSeason = () => {
    setSeasonFilter(seasonFilter == null?true:seasonFilter?false:null)
  }
  const filterDiscount = () => {
    setDiscountFilter(discountFilter == null?true:discountFilter?false:null)
  }
  
  const getTarget = (e) => {
    return e.currentTarget || e.target
  }

  const changeVendor = (e) => {
    setVendorName(getTarget(e).value)
  }
  const changeSupplier = (e) => {
    setSupplierId(getTarget(e).value)
  }
  const changeClient = (e) => {
    setClientId(getTarget(e).value)
  }
  
  const [selected, setselected] = React.useState([]);
  const setmodel = (m) => {
    if(m.length === 0)
      setSelectedProducts(false)
    setselected(m)
  }

  return(
    <Box sx={{ width: '90vw', }}>
      {selected.length > 0 && !roleCheck(user_roles)?<Alert variant="filled" severity="warning">
        Algunas opciones están bloqueadas para este usuario.
      </Alert>:""}
      <Paper sx={{ padding: "30px", display: 'flex', flexDirection: 'column' }}>
        <Box sx={{display:"flex", justifyContent: "space-between"}}>
          <Box sx={{display:"flex", flexDirection: "column"}}>
            <Box>
              <Button onClick={setOpen}>Crear Producto</Button>
              <Button onClick={refresh}><RefreshIcon/>Actualizar</Button>
              {/* {selected.length > 0 && selected.length < totalProducts && <IconButton onClick={bulkDelete}><DeleteIcon/></IconButton>} */}
            </Box>
            <Box>
              <Typography paddingLeft="8px">
                {selected.length? (selected.length === 1 && `${selected.length} producto seleccionado`) || `${selected.length} productos seleccionados`:"" }
              </Typography>
            </Box>
          </Box>
          <Box sx={{display:"flex", flexDirection: "column"}}>
            <Box sx={{display:"flex", justifyContent: "end",}}>
              <Tooltip title="Temporada">
                <Button onClick={filterSeason}><DiscountIcon/> <Typography>Mostrando {`${seasonFilter == null?"Todos":seasonFilter?"Con Temporada":"Sin Temporada"}`}</Typography></Button>
              </Tooltip>
              <Tooltip title="Descuento">
                <Button onClick={filterDiscount}><PercentIcon/> <Typography>Mostrando {`${discountFilter == null?"Todos":discountFilter?"Con Descuento":"Sin Descuento"}`}</Typography></Button>
              </Tooltip>
              <Tooltip title="Cliente">
                <Button onClick={filterClient}><PersonIcon/> <Typography>Mostrando {`${clientFilter == null?"Todos":clientFilter?"Con Cliente":"Sin Cliente"}`}</Typography></Button>
              </Tooltip>
              <Tooltip title="Proveedor">
                <Button onClick={filterSupplier}><AccountBoxIcon/> <Typography>Mostrando {`${supplierFilter == null?"Todos":supplierFilter?"Con Proveedor":"Sin Proveedor"}`}</Typography></Button>
              </Tooltip>
            </Box>
            <Box sx={{display:"flex", flexDirection: "column", justifyContent: "end",}}>
              <Box sx={{display:"flex", justifyContent: "end",}}>
                {selected.length > 0 && <Button disabled={!roleCheck(user_roles)} onClick={assignCurrency}><Typography><CurrencyPoundIcon/> Asignar Moneda</Typography></Button>}
                {selected.length > 0 && <Button onClick={assignClient}><Typography><EditIcon/> Asignar Cliente</Typography></Button>}
                {selected.length > 0 && <Button onClick={assignSupplier}><Typography><EditIcon/> Asignar Proveedor</Typography></Button>}
              </Box>
              <Box sx={{display:"flex", justifyContent: "end",}}>
                {selected.length > 0 && <Button disabled={!roleCheck(user_roles)} onClick={bulkEditCost}><Typography><AttachMoneyIcon/>Editar costo</Typography></Button>}
                {selected.length > 0 && <Button disabled={!roleCheck(user_roles)} onClick={bulkEditDiscount}><Typography><PercentIcon/>Editar descuento</Typography></Button>}
                {selected.length > 0 && <Button disabled={!roleCheck(user_roles)} onClick={bulkEditSeason}><Typography><DiscountIcon/>Editar temporada</Typography></Button>}
                {selected.length > 0 && <Button onClick={bulkEditDimensions}><Typography><SquareFootIcon/>Editar dimensiones</Typography></Button>}
              </Box>
            </Box>
            <Box sx={{display:"flex", justifyContent: "end"}}>
              <FormControl sx={{ m: 1, width: '25ch' }} >
                <InputLabel id={"label-vendor"}>Canal</InputLabel>
                <Select
                  labelId="label-vendor"
                  name="vendor"
                  label="Canal"
                  value={vendorName}
                  onChange={changeVendor}
                >
                  <MenuItem value={0}>Todos</MenuItem>
                  {vendors && vendors.map(vendor => (
                    <MenuItem value={vendor.alias}>{vendor.name}</MenuItem>
                  ))}
                  </Select>
              </FormControl>
              <FormControl sx={{ m: 1, width: '25ch' }} >
                <InputLabel id={"label-client"}>Cliente</InputLabel>
                <Select
                  labelId="label-client"
                  name="client"
                  label="Cliente"
                  value={clientId}
                  onChange={changeClient}
                >
                  <MenuItem value={0}>Todos</MenuItem>
                  {clients && clients.map(client => (
                    <MenuItem value={client.id}>{client.name}</MenuItem>
                  ))}
                  </Select>
              </FormControl>
              <FormControl sx={{ m: 1, width: '25ch' }} >
                <InputLabel id={"label-suppliers"}>Proveedores</InputLabel>
                <Select
                  labelId="label-suppliers"
                  name="supplier"
                  label="Proveedor"
                  value={supplierId}
                  onChange={changeSupplier}
                >
                  <MenuItem value={0}>Todos</MenuItem>
                  {suppliers && suppliers.map(supplier => (
                    <MenuItem value={supplier.id}>{supplier.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>
        <Box sx={{height: '80vh'}}>
          <Table
            model={selected}
            setmodel={setmodel}
            data={products.filter(appliedFilters)}
            quickFilterParser={(value) => [value]}
            columns={[
              { headerName: "SKU", field: "sku",
                renderCell: ProductSKU, minWidth: 150, hideable: false
              },
              {flex: 1, headerName: "Productos", field: "filter",
                renderCell: ProductDetail, hideable: false
              },
              
              { headerName:"ASIN/Publicacion", field:"asin" },
              { headerName:"Nombre", field:"name" },
              { headerName:"Canal", field:"vendor" },
              { headerName:"Moneda", field:"currency",  valueGetter: (currency) => currency? currency.name: "" },
              { headerName:"Costo", field:"cost",  valueGetter: (cost) => cost/100, type: "number" },
              { headerName:"% Descuento", field:"discount", type: "number" },
              
            ]}
            visibility={{
              asin: false,
              name: false,
              vendor: false,
              cost: false,
              currency: false,
              discount: false,
            }}
            options={{
              selection: true,
              pageSizes:[5, 10,25,50,100,250,500]
            }}
            sx={{ 
              overflowX: 'scroll', 
              "& .MuiDataGrid-main": {
                minWidth: '800px!important',
              }
            }}
          />
        </Box>
      </Paper>
      <CurrencySelection open={openCurrency} close={close}/>
      <ClientSelection open={openClient} close={close}/>
      <SupplierSelection open={openSupplier} close={close}/>
      <ProductDiscount open={openDiscount} close={close}/>
      <ProductSeason open={openSeason} close={close}/>
      <ProductCost open={openCost} close={close}/>
      <ProductDimensions open={openDimensions} close={close}/>
      <ProductDelete open={openDelete} close={close}/>
    </Box>
  )
}
export default ProductList

const muiInput = (theme, diff) => ({
  "& .Mui-disabled": {
    color: (diff?theme.palette.error.main:"black")+"!important",
    "-webkit-text-fill-color": (diff?theme.palette.error.main:"black")+"!important",
    marginRight: "15px"
  }
})


const getVendorBackground = (v) => {
  switch(v){
    case "amazon": return "#192c3b"
    case "mercado": return "#ffe700"
    default: return "grey"
  }
}
const getVendorColor = (v) => {
  switch(v){
    case "amazon": return "#fff"
    case "mercado": return "#8e1897"
    default: return "grey"
  }
}
function ProductSKU({row}){
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      <Button  sx={{textTransform : "none"}} onClick={() => navigator.clipboard.writeText(row.sku)} color="primary">{row.sku}</Button>
    </Box>
  )
}

function ProductDetail({row}){
  const theme = useTheme()
  let difClient = false
  let client = null 
  row.listings.forEach((l) => {
    const row_client = l.client?l.client.name:"Sin Cliente"
    if(!client)
      client = row_client
    else if(client !== row_client)
      difClient = true
  })
  
  let difSup = false
  let supplier = null 
  row.listings.forEach((l) => {
    const row_supplier = l.supplier?l.supplier.name:"Sin Proveedor"
    if(!supplier)
      supplier = row_supplier
    else if(supplier !== row_supplier)
      difSup = true
  })
  
  let difDim = false
  let height = null, width = null, depth = null, weight = null
  row.listings.forEach((l) => {
    const row_height = l.productdimension? l.productdimension.height : 0
    const row_width = l.productdimension? l.productdimension.width : 0
    const row_depth = l.productdimension? l.productdimension.depth : 0
    const row_weight = l.productdimension? l.productdimension.weight : 0

    if(isNaN(parseFloat(height)))
      height = row_height
    else if(height != row_height)
      difDim = true
    if(isNaN(parseFloat(width)))
      width = row_width
    else if(width != row_width)
      difDim = true
    if(isNaN(parseFloat(depth)))
      depth = row_depth
    else if(depth != row_depth)
      difDim = true
    if(isNaN(parseFloat(weight)))
      weight = row_weight
    else if(weight != row_weight)
      difDim = true
  })

  if(height == null)
    height = 0
  if(width == null)
    width = 0
  if(depth == null)
    depth = 0
  if(weight == null)
    weight = 0
  if( height === 0 || width === 0 || depth === 0 || weight === 0 )
    difDim = true

  
  
  return (
    <Box padding={2} sx={{flex: 1, display: 'flex', flexDirection: 'column', }}>
      <Badge badgeContent={(
        <Box sx={{
          position: 'absolute', 
          left: 15, 
          top:3, 
          display: 'flex',
          flexDirection: 'row',
        }}>
          {row.listings.map(
            (l) => 
            <Chip key={l.id}
              sx={{
                margin: '2px', 
                backgroundColor: getVendorBackground(l.vendor),
                color: getVendorColor(l.vendor),
              }}
              onClick={() => navigator.clipboard.writeText(l.asin)}
              label={`${l.vendor}: ${l.asin}`}
            />
          )}
        </Box>
      )} sx={{ flex: 1, display: 'flex', marginBottom: '12px'}} anchorOrigin={{ vertical: 'top', horizontal: 'left', }}>
        <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', paddingTop: '36px'}}>
          <Accordion id={row.id+"accordion"}>
            <AccordionSummary
              id={row.id+"accordionsummary"}
              expandIcon={<ExpandMoreIcon />}
            >
              <Box sx={{flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: '15px'}}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center'}}>
                  <Typography variant="h5" marginLeft={3} color={difClient?"error":""}>{client || (difClient?"Diferentes Clientes":"Sin Cliente")}</Typography>
                  <Typography marginLeft={3} color={difSup?"error":""}>{supplier || (difSup?"Diferentes Proveedores":"Sin Proveedor")}</Typography>
                </Box>
                <Discount row={row} />
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingRight: '15px'}}>
                {row.listings.map((l, i) => 
                <React.Fragment>
                  <Box padding={2}>
                    <Typography><strong>{l.client? l.client.name: "Sin Cliente"}</strong> {l.supplier? l.supplier.name: "Sin Proveedor"}</Typography>
                    <Typography>{l.name}</Typography>
                    <Typography>Costo: MXN {money.format(getCost(l.cost, l.discount, l.season, l) * l.currency.rate)}</Typography>
                    {l.vendor === "mercado" && <Typography>Precio: MXN {money.format(Number(l.price/100))}</Typography>}
                    <Typography>Costo estimado de envio: {
                      l.productdimension?
                        isNaN(l.productdimension.shippingcost[l.vendor])?
                          "N/A":
                          `MXN ${money.format(l.productdimension.shippingcost[l.vendor])}`
                        : "N/A"
                    }</Typography>
                    <Chip key={l.id}
                      sx={{
                        margin: '2px', 
                        backgroundColor: getVendorBackground(l.vendor),
                        color: getVendorColor(l.vendor),
                        borderRadius: '5px',
                      }}
                      onClick={() => navigator.clipboard.writeText(l.asin)}
                      label={`${l.vendor}: ${l.asin}`}
                    />
                    
                  </Box>
                  <Divider />
                </React.Fragment>
                )}
                <Box padding="15px" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start'}}>
                  <TextField
                    disabled
                    label="Alto"
                    sx={muiInput(theme, difDim)}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                    }}
                    value={height}
                  />
                  <TextField
                    disabled
                    label="Ancho"
                    sx={muiInput(theme, difDim)}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                    }}
                    value={width}
                  />
                  <TextField
                    disabled
                    label="Largo"
                    sx={muiInput(theme, difDim)}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                    }}
                    value={depth}
                  />
                  <TextField
                    disabled
                    label="Peso"
                    sx={muiInput(theme, difDim)}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">g</InputAdornment>,
                    }}
                    value={weight}
                  />
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Badge>
    </Box>
  )
  
}